module.exports = __webpack_public_path__ + "img/pro_three.68729473.jpg";